import { getStore, setStore } from "@/utils/store";
import { encryption } from "@/utils/util";

import { defineStore } from "pinia";
import { resetRouter } from "@/router";

import {
  getUserInfo,
  loginByUsername,
  loginByMobile,
  logout,
  refreshToken,
} from "@/apis/login";

const useUserStore = defineStore({
  id: "users",
  state: () => ({
    userInfo:
      getStore({
        name: "user_info",
      }) || {},
    access_token:
      getStore({
        name: "access_token",
      }) || "",
    refresh_token:
      getStore({
        name: "refresh_token",
      }) || "",
  }),
  getters: {
    hasLogin: (state) => {
      return state.access_token !== undefined && state.access_token !== "";
    },
  },
  actions: {
    // 根据用户名登录
    loginByUsername(userInfo) {
      const user = encryption({
        data: userInfo,
        key: "thanks,pig4cloud",
        param: ["password"],
      });
      return new Promise((resolve, reject) => {
        loginByUsername(user.username, user.password, user.code, user.randomStr)
          .then((response) => {
            const data = response.data;
            this.setAccessToken(data.access_token);
            this.setRefreshToken(data.refresh_token);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 根据手机号登录
    loginByPhone(userInfo) {
      return new Promise((resolve, reject) => {
        loginByMobile(userInfo.phone, userInfo.code)
          .then((response) => {
            const data = response.data;
            this.setAccessToken(data.access_token);
            this.setRefreshToken(data.refresh_token);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getUserInfo() {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((res) => {
            const data = res.data.data || {};
            this.setUserInfo(data.sysUser);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    // 刷新token
    refreshToken() {
      return new Promise((resolve, reject) => {
        refreshToken(this.refresh_token)
          .then((response) => {
            const data = response.data;
            this.setAccessToken(data.access_token);
            this.setRefreshToken(data.refresh_token);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 登出
    logOut() {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            this.setUserInfo({});
            this.setAccessToken("");
            this.setRefreshToken("");
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 注销session
    fedLogOut() {
      return new Promise((resolve) => {
        this.setUserInfo({});
        this.setAccessToken("");
        this.setRefreshToken("");
        resetRouter();
        resolve();
      });
    },
    setUserInfo(userInfo) {
      this.userInfo = userInfo;
      setStore({
        name: "user_info",
        content: userInfo,
      });
    },
    setAccessToken(access_token) {
      this.access_token = access_token;
      setStore({
        name: "access_token",
        content: access_token,
      });
    },
    setRefreshToken(refresh_token) {
      this.refresh_token = refresh_token;
      setStore({
        name: "refresh_token",
        content: refresh_token,
      });
    },
  },
});
export default useUserStore;
